import { api, apiDelete, apiJson } from './client.js';

function basePath(modelId) {
  return `/admin/models/${modelId}/fansly-fyp`;
}

export async function getFanslyFyp(modelId) {
  return apiJson(`${basePath(modelId)}?limit=500`, {}, 'Failed to load Fansly FYP');
}

export async function getFanslyFypAnalytics(modelId, range = 'last_24h', refresh = false) {
  const params = new URLSearchParams({ range });
  if (refresh) params.set('refresh', 'true');
  return apiJson(
    `${basePath(modelId)}/analytics?${params.toString()}`,
    {},
    'Failed to load Fansly FYP analytics',
  );
}

export async function updateFanslyFypSettings(modelId, settings) {
  return apiJson(
    `${basePath(modelId)}/settings`,
    { method: 'PUT', body: JSON.stringify(settings) },
    'Failed to save Fansly FYP settings',
  );
}

export async function uploadFanslyFypArchive(modelId, file) {
  const body = new FormData();
  body.append('archive', file);
  return apiJson(
    `${basePath(modelId)}/archive`,
    { method: 'POST', body, skipContentType: true },
    'Failed to import Fansly FYP archive',
  );
}

export async function uploadFanslyFypMedia(modelId, files, defaultCaption = '') {
  const body = new FormData();
  Array.from(files || []).forEach((file) => body.append('files', file));
  if (defaultCaption.trim()) body.append('default_caption', defaultCaption.trim());
  return apiJson(
    `${basePath(modelId)}/media`,
    { method: 'POST', body, skipContentType: true },
    'Failed to add Fansly media',
  );
}

export async function updateFanslyFypItem(modelId, itemId, updates) {
  return apiJson(
    `${basePath(modelId)}/items/${itemId}`,
    { method: 'PATCH', body: JSON.stringify(updates) },
    'Failed to update Fansly FYP item',
  );
}

export async function deleteFanslyFypItem(modelId, itemId) {
  await apiDelete(
    `${basePath(modelId)}/items/${itemId}`,
    'Failed to delete Fansly FYP item',
  );
}

export async function publishFanslyFypItemNow(modelId, itemId, { confirmReviewRetry = false } = {}) {
  return apiJson(
    `${basePath(modelId)}/items/${itemId}/publish`,
    { method: 'POST', body: JSON.stringify({ confirm_review_retry: confirmReviewRetry }) },
    'Failed to publish Fansly FYP item',
  );
}

export async function retryFanslyFypItem(modelId, itemId, options = {}) {
  return publishFanslyFypItemNow(modelId, itemId, options);
}

export async function fetchFanslyFypPreview(modelId, itemId) {
  const response = await api(`${basePath(modelId)}/items/${itemId}/file`, {
    headers: {},
  });
  if (!response.ok) throw new Error('Fansly FYP preview is unavailable');
  return URL.createObjectURL(await response.blob());
}
